import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, TextLink, Text } from '@indeed/ifl-components';
import LightApplyNavigation from './LightApplyNavigation';
import LightApplyHeader from './components/LightApplyHeader';
import FeedbackModal from './components/FeedbackModal';
import { LocalStorageInspector } from '../../components/DevelopmentInfo';

const LightApplyLayout: React.FunctionComponent = () => {
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

    const handleChatClick = () => {
        // Handle chat functionality
    };

    const handleNotificationClick = () => {
        // Handle notification functionality
    };

    const handleMenuClick = () => {
        // Handle menu functionality
    };

    return (
        <Box
            sx={{
                minBlockSize: '100vh',
                display: 'flex',
                flexDirection: 'column',
                gap: '0px',
            }}
        >
            {/* Top Header with Logo and Icons */}
            <LightApplyHeader
                onChatClick={handleChatClick}
                onNotificationClick={handleNotificationClick}
                onMenuClick={handleMenuClick}
            />

            {/* Light Apply Navigation Header */}
            <LightApplyNavigation />

            {/* Main Content Area */}
            <Box
                sx={{
                    flex: 1,
                    maxInlineSize: '480px',
                    margin: '0 auto',
                    inlineSize: '100%',
                    paddingInline: 3,
                }}
            >
                <Outlet />
            </Box>
            <LocalStorageInspector position="bottom-right" />

            {/* Help Text Footer */}
            <Box
                sx={{
                    padding: '16px',
                    textAlign: 'center',
                    maxInlineSize: '480px',
                    margin: '0 auto',
                    inlineSize: '100%',
                    paddingInline: 3,
                }}
            >
                <Text
                    sx={{
                        color: 'foreground.secondary',
                        fontSize: 1,
                        fontFamily: 'default',
                    }}
                >
                    応募で問題が発生していますか？
                    <Box sx={{ display: 'block' }}>
                        <TextLink
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                setIsFeedbackModalOpen(true);
                            }}
                            sx={{
                                color: 'foreground.secondary',
                                fontSize: 1,
                                textDecoration: 'underline',
                            }}
                        >
                            こちらからお聞かせください
                        </TextLink>
                        。
                    </Box>
                    <Box sx={{ marginBlockStart: '24px' }}>
                        このサイトはreCAPTCHAによって保護されており、Googleの
                        <TextLink
                            href="https://jp.indeed.com/legal#privacy"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: 'foreground.secondary',
                                fontSize: 1,
                                textDecoration: 'underline',
                            }}
                        >
                            プライバシー規約
                        </TextLink>
                        と
                        <TextLink
                            href="https://jp.indeed.com/legal#tos"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: 'foreground.secondary',
                                fontSize: 1,
                                textDecoration: 'underline',
                            }}
                        >
                            利用規約
                        </TextLink>
                        が適用されます。
                    </Box>
                </Text>
            </Box>

            {/* Feedback Modal */}
            <FeedbackModal
                isOpen={isFeedbackModalOpen}
                onClose={() => setIsFeedbackModalOpen(false)}
            />
        </Box>
    );
};

export default LightApplyLayout;
